import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTasks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTasks"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM11 8.75H17V10.25H11V8.75ZM11 13.75V15.25H17V13.75H11ZM9 14.5C9 15.0523 8.55229 15.5 8 15.5C7.44772 15.5 7 15.0523 7 14.5C7 13.9477 7.44772 13.5 8 13.5C8.55229 13.5 9 13.9477 9 14.5ZM8 10.5C8.55229 10.5 9 10.0523 9 9.5C9 8.94771 8.55229 8.5 8 8.5C7.44772 8.5 7 8.94771 7 9.5C7 10.0523 7.44772 10.5 8 10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTasks;
